<template>
  <div class="row">
    <div class="col-lg-4"></div>
    <div class="col-lg-4">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <span class="input-group-text">R$</span>
        </div>
        <currency-input
          v-model="value"
          class="form-control"
          placeholder="0,00"
        />
      </div>
    </div>
    <div class="col-lg-4"></div>
    <div class="col-lg-4"></div>
    <div class="col-lg-4">
      <button @click="saveAnswer" class="btn btn-primary full">
        Enviar resposta
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["question", "index", "currentTime", "answers"],
  data: () => ({
    value: 0,
  }),
  mounted() {
    if (this.answers?.length > 0) {
      const answer = this.answers.find(
        (answer) => answer.question_id == this.question.id
      );
      if (answer) {
        this.value = answer.choices.currency;
      }
    }
  },
  methods: {
    saveAnswer() {
      let answers = {
        question_id: this.question.id,
        time_taken: this.currentTime,
        choices: {
          currency: this.value,
        },
      };

      axios.post("/candidates/answers", { answers }).then((response) => {
        if (response.status) {
          eventBus.$emit("nextQuestion", this.index);
          this.$emit("saveAnswers", answers);
        }
      });
    },
  },
};
</script>